<template>
  <ul class="grid grid-cols-3 answers gap-6">
    <li
      class="btn answer rounded-lg shadow-card p-4 lg:p-8 flex justify-center items-center cursor-pointer w-full"
      v-for="(answer, index) in answers"
      :class="[ currentAnswer === answer.id ? 'answer--selected' : '', getWidthStyle(answer.width)]"
      :key="index"
      @click="selectAnswer(answer.id)"
    >
      <span class="font-semibold text-center">{{ answer.answer }}</span>
    </li>
  </ul>
</template>

<script>
  export default {
    props: {
      value: Number,
      answers: Array
    },
    data() {
      return {
        currentAnswer: this.value
      }
    },
    mounted() {
      this.currentAnswer = this.value
    },
    methods: {
      selectAnswer(answer) {
        this.currentAnswer = answer
        this.$emit('input', this.currentAnswer)
      },

      getWidthStyle(answer) {
        let width;

        switch(answer) {
          case '1':
            width = 'col-span-1';
            break;

          case '2':
            width = 'col-span-2';
            break; 

          case '3':
            width = 'col-span-3';
            break;
        }

        return width
      }
    }
  }
</script>

<style scoped lang="scss">
  

  .answer {
    min-height: 140px;
    background: white;
    transition: all 0.2s;

    &:hover {
      background: #e2e2e2;
    }

  }

  .answer--selected {
    background: #F75F39;
    color: white;

    &:hover {
      background: #de5b3b;
    }
  }
</style>
